import { toast } from 'react-toastify';

import { callApi } from '../../../../../apiCaller';
import { API_GET_USER_PRODUCTS_EVENTS, API_SYSTEM_ADMIN_FIND_DATA_PRODUCT, DEFAULT_FN } from '../../../../../constants';
import { toastError } from '../../../../../utils';

export const SET_ADMIN_DATA_ADD_PRODUCT = 'setAdminDataAddProduct';

export const API_SYSTEM_ADMIN_ORGANIZATION_USER_DATA_LISTS = 'organization-user/data-lists';
export const API_SYSTEM_ADMIN_SEND_EMAIL_INVOICE = 'order/send-email-invoice';

export const setAdminDataAddProduct = (payload) => {
     return {
          type: SET_ADMIN_DATA_ADD_PRODUCT,
          payload,
     };
};

export const fetchFindDataProductRequest = () => (dispatch) => {
     callApi(API_SYSTEM_ADMIN_FIND_DATA_PRODUCT, 'GET').then((response) => {
          if (response.status === 200) {
               dispatch(setAdminDataAddProduct(response.data));
          } else {
               toastError(response);
          }
     });
};

export const fetchAllUserProductsEventFilter = async (payload) => {
     const { userId, productIds, relatedProductId, type } = payload;

     if (!userId) return [];

     const filter = {
          userId,
     };

     if (productIds?.length) filter.productIds = productIds;

     if (relatedProductId) filter.relatedProductId = relatedProductId;

     if (type) filter.type = type;

     const filterQuery = Object.keys(filter).length ? `?filter=${encodeURIComponent(JSON.stringify(filter))}` : '';
     const endpoint = API_GET_USER_PRODUCTS_EVENTS + filterQuery;

     return await callApi(endpoint, 'GET').then((response) => {
          if (response.status !== 200) {
               toastError(response);
               return [];
          }

          const coursesRes = response.data;
          const newListTrainingEvent = [];

          for (let i = 0; i < coursesRes.length; i++) {
               const courseEvent = coursesRes[i];
               const event = courseEvent.event;
               if (!event) continue;

               newListTrainingEvent.push({
                    id: event.id,
                    name: event.name,
                    selected: false,
               });
          }

          return newListTrainingEvent;
     });
};

export const fetchAdminOrganizationUserDataLists = (paginationPayload, nextDispatch) => () => {
     const { setOrganizationUsers, setIsLoading = DEFAULT_FN } = nextDispatch;
     const { filter, page, pageSize, sortBy, sortType } = paginationPayload;
     const filterQuery = Object.keys(filter).length ? `&filter=${encodeURIComponent(JSON.stringify(filter))}` : '';
     const endPoint = `${API_SYSTEM_ADMIN_ORGANIZATION_USER_DATA_LISTS}?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortType=${sortType}${filterQuery}`;

     callApi(endPoint, 'GET').then((response) => {
          setIsLoading(false);

          if (response.status !== 200) {
               toastError(response);
               return;
          }

          const organizationUserResponse = response.data;
          setOrganizationUsers(organizationUserResponse);
     });
};

export const systemAdminSendEmailInvoice = async (payload) => {
     return await callApi(API_SYSTEM_ADMIN_SEND_EMAIL_INVOICE, 'POST', payload).then((response) => {
          if (response.status !== 200) {
               toastError(response);
               return;
          }

          toast.success('Invoice email sent successfully!');
          return response.data;
     });
};
